import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, CircleMarker, Popup } from "react-leaflet";
import { CATEGORY_META, currency } from "@/lib/constants";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function MapView({ height = 520, initialCategory = null }) {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState(initialCategory);

  useEffect(() => {
    const params = new URLSearchParams();
    if (cat) params.set("category", cat);
    params.set("limit", "500");
    api.get(`/opportunities/map?${params.toString()}`).then((r) => setItems(r.data.items || []));
  }, [cat]);

  return (
    <div className="relative rounded-lg overflow-hidden border border-[#33291f]" style={{ height }} data-testid="map-view">
      <div className="absolute z-[500] top-3 left-3 glass rounded-md px-3 py-2 flex flex-wrap gap-1.5 max-w-[calc(100%-24px)]">
        <button
          data-testid="map-filter-all"
          onClick={() => setCat(null)}
          className={`text-[10px] uppercase tracking-wider px-2 py-1 rounded border ${!cat ? "bg-[#d4a574] text-[#14100c] border-[#d4a574]" : "border-[#4a3a2b] text-[#b8ac96] hover:text-[#f4ede2]"}`}
        >All</button>
        {Object.entries(CATEGORY_META).slice(0, 8).map(([key, m]) => (
          <button
            key={key}
            data-testid={`map-filter-${key}`}
            onClick={() => setCat(key)}
            className={`text-[10px] uppercase tracking-wider px-2 py-1 rounded border flex items-center gap-1 ${cat === key ? "border-[#d4a574]" : "border-[#4a3a2b] text-[#b8ac96] hover:text-[#f4ede2]"}`}
            style={cat === key ? { color: m.color } : {}}
          >
            <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: m.color }} />
            {m.label}
          </button>
        ))}
      </div>
      <div className="absolute z-[500] bottom-3 left-3 glass rounded-md px-3 py-2 text-[10px] font-mono text-[#b8ac96]">
        {items.length} opportunities · US Nationwide
      </div>
      <MapContainer center={[39.5, -98.35]} zoom={4} style={{ height: "100%", width: "100%" }} scrollWheelZoom={true} preferCanvas>
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {items.map((it) => {
          const c = CATEGORY_META[it.category]?.color || "#d4a574";
          const score = it.ai_score?.opportunity || 50;
          const radius = 5 + Math.min(10, score / 12);
          return (
            <CircleMarker
              key={it.id}
              center={[it.latitude, it.longitude]}
              radius={radius}
              pathOptions={{ color: c, fillColor: c, fillOpacity: 0.75, weight: 1.5 }}
            >
              <Popup>
                <div className="min-w-[200px]">
                  {it.image_url && <img src={it.image_url} alt="" className="w-full h-24 object-cover rounded mb-2" />}
                  <div className="font-semibold text-sm text-[#f4ede2] mb-1">{it.title}</div>
                  <div className="text-xs text-[#b8ac96] mb-1.5">{it.city}, {it.state}</div>
                  <div className="flex items-center justify-between text-xs">
                    <span className="font-mono text-[#d4a574]">{currency(it.price)}</span>
                    <span className="font-mono">Score {Math.round(score)}</span>
                  </div>
                  <Link to={`/app/opportunities/detail/${it.id}`} className="mt-2 block text-center text-[10px] uppercase tracking-wider text-[#d4a574] border border-[#4a3a2b] rounded py-1 hover:bg-[#241d16]">View Details →</Link>
                </div>
              </Popup>
            </CircleMarker>
          );
        })}
      </MapContainer>
    </div>
  );
}
